import { createSceneReducer } from 'reducers/reducers-util';
import ownerAuthorizedRepsDataReducer from 'components/admin/owner-authorized-reps/store/reducers.data';
import ownerAuthorizedRepsUiReducer from 'components/admin/owner-authorized-reps/store/reducers.ui';

export default createSceneReducer(
  ownerAuthorizedRepsDataReducer,
  ownerAuthorizedRepsUiReducer
);
